import { Injectable } from "@angular/core";

// rxjs
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

// Store
import { AssignmentsService } from "@carnegie-learning/data-access-angular-passport";
import * as fromCartActions from "../actions/cart-properties.action";

// Services

@Injectable()
export class CartPropertiesEffects {
    constructor(
        private actions$: Actions,
        private assignmentsService: AssignmentsService
    ) {}

    checkAssetInUse$ = createEffect(() =>
        this.actions$.pipe(ofType(fromCartActions.checkAssetInUse)).pipe(
            switchMap(({ asset }) => {
                return this.assignmentsService
                    .getAssignmentsByAssetId(asset.assetId)
                    .pipe(
                        map((response) => {
                            return fromCartActions.checkAssetInUseSuccess(
                                {
                                    bool: !!response?.data?.length,
                                }
                            );
                        }),
                        catchError((error) =>
                            of(
                                fromCartActions.checkAssetInUseFail({
                                    payload: error,
                                })
                            )
                        )
                    );
            })
        )
    );
}
